<template>
  <div>
    <template>
      <div class="row align-items-start justify-content-center" :class="{ 'flex-column': isMobile }">
        <div class="col-md-6 my-2" :class="{'w-100': isMobile}" v-if="isHdDownloadEnabled">
          <ButtonDownloadPhoto :media="media"
                               :quality="mediaQuality.HD"
                               @click="$emit('click')"/>
        </div>
        <div class="col-md-6 my-2" :class="{'w-100': isMobile}" v-if="isSdDownloadEnabled">
          <ButtonDownloadPhoto :media="media"
                               :quality="mediaQuality.SD"
                               @click="$emit('click')"/>
        </div>
      </div>
    </template>

  </div>
</template>

<script>
import ButtonDownloadPhoto from "@/domain/galleries/medias/ButtonDownloadPhoto.vue";
import {mediaQuality} from "@/domain/galleries/constants";
import {mapGetters} from "vuex";

export default {
  name: "DownloadActions",
  components: {ButtonDownloadPhoto},
  emits: ['click'],
  props: {
    media: {
      type: Object,
      required: true
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    isHdDownloadEnabled: {
      type: Boolean,
      default: false
    },
    isSdDownloadEnabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('checkinDetail', [
      'hdServingType'
    ]),
    mediaQuality() {
      return mediaQuality;
    },
  },
}
</script>

<style scoped>
/* Add any scoped styles here */
</style>